"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genders = void 0;
exports.genders = ["male", "female", "non-binary"];
